(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tu-buy-list"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('tu-hunt');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const text = JSON.parse(root.querySelector('[data-hunt-text]').textContent);
    const form = root.querySelector('#TUHuntForm');
    const newsletter = root.querySelector('[data-newsletter-step]');
    if (root.querySelector('.receipt')) {
      try { newsletter.hidden = sessionStorage.getItem('tu-hunt-newsletter') !== 'yes'; sessionStorage.removeItem('tu-hunt-newsletter'); } catch (_) {}
      return;
    }
    if (!form) return;
    const range = root.querySelector('[type=range]');
    const output = root.querySelector('output');
    const conditions = Object.values(text.conditions);
    for (const group of root.querySelectorAll('[data-condition]')) {
      const name = group.dataset.condition;
      conditions.forEach((labelText, i) => {
        const label = document.createElement('label'), input = document.createElement('input');
        input.type = 'radio'; input.name = name; input.value = i;
        input.checked = i === (name === 'preferred' ? 0 : 1);
        label.append(input, document.createTextNode(labelText)); group.append(label);
      });
    }
    const formats = root.querySelector('[data-formats]');
    Object.values(text.formats).forEach((labelText, i) => {
      const label = document.createElement('label'), input = document.createElement('input');
      label.className = 'choice'; input.type = 'checkbox'; input.name = 'format'; input.value = labelText;
      input.checked = i === 5; input.disabled = true;
      label.append(input, document.createTextNode(labelText)); formats.append(label);
    });
    function updatePrice() {
      const value = Number(range.value), tier = value < 0 ? 'below' : value > 0 ? 'above' : 'market';
      const label = value === 0 ? text.at_market : Math.abs(value) + text[tier + '_market'];
      output.textContent = label; range.setAttribute('aria-valuetext', label);
      root.querySelector(`[name=price-tier][value=${tier}]`).checked = true;
    }
    range.addEventListener('input', updatePrice);
    form.addEventListener('change', event => {
      const input = event.target;
      if (input.name === 'hunt-kind') {
        for (const panel of root.querySelectorAll('[data-panel]')) {
          const active = panel.dataset.panel === input.value;
          panel.hidden = !active;
          for (const field of panel.querySelectorAll('input')) field.disabled = !active;
        }
        form.elements['sealed-set'].required = input.value === 'sealed';
        form.elements['product-name'].required = input.value === 'collectible';
        form.elements.manufacturer.required = input.value === 'collectible';
      }
      if (input.name === 'price-tier') { range.value = {below:-20, market:0, above:15}[input.value]; updatePrice(); }
      if (input.name === 'preferred' || input.name === 'minimum') {
        let best = Number(form.elements.preferred.value), worst = Number(form.elements.minimum.value);
        if (best > worst) {
          const other = input.name === 'preferred' ? 'minimum' : 'preferred';
          root.querySelector(`[name=${other}][value="${input.value}"]`).checked = true;
          best = Number(form.elements.preferred.value); worst = Number(form.elements.minimum.value);
        }
        root.querySelector('[data-condition-note]').textContent = best === worst ? `${conditions[best]} ${text.condition_only}` : `${text.condition_from} ${conditions[best]} ${text.condition_through} ${conditions[worst]}.`;
      }
      if (input.name === 'format') {
        const all = [...formats.querySelectorAll('input')], any = all[all.length - 1];
        if (input === any && input.checked) all.slice(0,-1).forEach(x => x.checked = false);
        else if (input.checked) any.checked = false;
        if (!all.some(x => x.checked)) any.checked = true;
      }
    });
    form.addEventListener('submit', () => {
      const value = name => form.elements[name].value.trim();
      const kind = value('hunt-kind');
      const huntLabels = {card:'A specific card', sealed:'Sealed TCG products', collectible:'A collectible or other product'};
      const lines = ['TRUE UNICORN BUY LIST', `Full name: ${value('contact[name]')}`, `Email: ${value('contact[email]')}`, `Hunt: ${huntLabels[kind]}`];
      if (kind === 'card') lines.push(`Card name: ${value('card-name')}`, `Card number: ${value('card-number') || 'Not specified'}`, `Set / printing: ${value('card-set') || 'Not specified'}`, `Preferred condition: ${conditions[Number(value('preferred'))]}`, `Lowest acceptable: ${conditions[Number(value('minimum'))]}`);
      else if (kind === 'sealed') lines.push(`Set: ${value('sealed-set')}`, `Formats: ${[...formats.querySelectorAll('input:checked')].map(x=>x.value).join(', ')}`);
      else lines.push(`Product name: ${value('product-name')}`, `Manufacturer: ${value('manufacturer')}`, `Product type: ${value('product-type') || 'Not specified'}`, `Theme / franchise: ${value('theme') || 'Not specified'}`, `UPC / barcode: ${value('upc') || 'Not specified'}`, `Model / item number: ${value('model-number') || 'Not specified'}`, `Edition / variant: ${value('edition') || 'Not specified'}`, `Size / scale: ${value('size-scale') || 'Not specified'}`, `Release date / window: ${value('release-window') || 'Not specified'}`, `Reference URL: ${value('reference-url') || 'Not specified'}`);
      lines.push(`Language: ${value('language')}`, `Price target: ${output.textContent}`, `Maximum total budget (USD): ${value('budget') || 'Not specified'}`, `Notes: ${value('notes') || 'None'}`, 'Terms accepted: Yes', 'Confirmation email acknowledged: Yes', `Email updates requested: ${form.elements.newsletter.checked ? 'Yes (separate signup)' : 'No'}`);
      const summary = lines.join('\n');
      const payload = {version:1, email:value('contact[email]'), name:value('contact[name]'), summary, price:Number(range.value), terms:true, confirmation:true};
      const encoded = btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(payload))));
      root.querySelector('[data-summary]').value = summary;
      root.querySelector('[data-payload]').value = 'TUBUYLISTV1START' + encoded + 'TUBUYLISTV1END';
      try { sessionStorage.setItem('tu-hunt-newsletter',form.elements.newsletter.checked?'yes':'no'); } catch (_) {}
    });
    root.querySelector('.submit').disabled = false;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();
})();
